import { render } from "./SAPReport.vue?vue&type=template&id=f98a39ae&scoped=true"
import script from "./SAPReport.vue?vue&type=script&lang=js"
export * from "./SAPReport.vue?vue&type=script&lang=js"

import "./SAPReport.vue?vue&type=style&index=0&id=f98a39ae&scoped=true&lang=css"

import exportComponent from "/private/var/www/html/digicheck-laravel-vue-app/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f98a39ae"]])

export default __exports__